// Inline SVG icon set — the field-kit pictograms. One consistent family:
// 24px grid, 1.7px round strokes, currentColor (so amber/active states are
// free). No icon font, no external assets.

const PATHS: Record<string, string> = {
  // crosshair scope — HQ / command
  hq: `<circle cx="12" cy="12" r="6.5"/><path d="M12 2.8v3M12 18.2v3M2.8 12h3M18.2 12h3"/><circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none"/>`,
  // folded field map
  map: `<path d="M3.5 6.3l5.5-2 6 2 5.5-2v13.4l-5.5 2-6-2-5.5 2z"/><path d="M9 4.3v13.4M15 6.3v13.4"/>`,
  // dossier folder with tab
  cases: `<path d="M3 18V6.2c0-.7.5-1.2 1.2-1.2H8.6L10.8 7h9c.7 0 1.2.5 1.2 1.2V18c0 .7-.5 1.2-1.2 1.2H4.2C3.5 19.2 3 18.7 3 18z"/>`,
  // water gun
  caches: `<path d="M4 9h13.2v4.4H9.6l-1.4 5.4H4.6L6 13.4H4z"/><path d="M17.2 10.4h2.6v1.8h-2.6"/><circle cx="21" cy="16" r="1.2" fill="currentColor" stroke="none"/>`,
  // surveillance camera
  proof: `<rect x="3" y="7" width="18" height="12.5" rx="1.8"/><path d="M8.6 7l1.5-2.2h3.8L15.4 7"/><circle cx="12" cy="13" r="3.4"/><circle cx="12" cy="13" r="0.9" fill="currentColor" stroke="none"/>`,
  // podium bars
  ranks: `<path d="M4 19.5v-5.3h4.2v5.3M9.9 19.5V6.5h4.2v13M15.8 19.5v-8h4.2v8"/><path d="M3 19.5h18"/>`,
  // fedora
  agent: `<path d="M3.6 16.2c3 1.4 13.8 1.4 16.8 0"/><path d="M7.4 15.7c-.3-4.2.8-8.4 4.6-8.4s4.9 4.2 4.6 8.4"/><path d="M7.6 13.4h8.8"/>`,
  // radar sweep
  radar: `<circle cx="12" cy="12.6" r="7.2"/><path d="M12 12.6l5-4.6"/><circle cx="15.2" cy="15.2" r="1.2" fill="currentColor" stroke="none"/><circle cx="12" cy="12.6" r="0.9" fill="currentColor" stroke="none"/>`,
  // typed report — chapters (admin)
  file: `<path d="M6.2 3h7.6L18.2 7.4V21H6.2z"/><path d="M13.8 3v4.4h4.4"/><path d="M9 12.4h6M9 16h6"/>`,
  // control sliders (admin)
  control: `<path d="M4 8h9M17.6 8H20M4 16h3.4M12 16h8"/><circle cx="15.3" cy="8" r="2"/><circle cx="9.7" cy="16" r="2"/>`,
  // signal bell (broadcasts)
  bell: `<path d="M6 16.5v-6a6 6 0 0 1 12 0v6l1.6 2.3H4.4z"/><path d="M10.2 21a2 2 0 0 0 3.6 0"/>`,
};

export function icon(name: keyof typeof PATHS | string, size = 22): HTMLElement {
  const span = document.createElement("span");
  span.className = "svgicon";
  span.innerHTML = `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${PATHS[name] ?? PATHS.hq}</svg>`;
  return span;
}
